import { request } from "../utils";
import { locationRestNewsletterSubscribePost } from "../wp-api";

async function subscribe(data) {
  await request({
    location: locationRestNewsletterSubscribePost,
    request: data
  });
}

export { subscribe };